import { render, staticRenderFns } from "./quiz_page.vue?vue&type=template&id=1dc0a8a2&"
import script from "./quiz_page.vue?vue&type=script&lang=js&"
export * from "./quiz_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app.whytemperament.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dc0a8a2')) {
      api.createRecord('1dc0a8a2', component.options)
    } else {
      api.reload('1dc0a8a2', component.options)
    }
    module.hot.accept("./quiz_page.vue?vue&type=template&id=1dc0a8a2&", function () {
      api.rerender('1dc0a8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js_src/quiz/quiz_page.vue"
export default component.exports